<template functional>
  <div class="share-data">
    <a
      v-if="props.project.company_logo"
      class="share-data__logo-link"
      data-cy="branding-preview-logo_link"
      :href="$options.companyLink(props.project)"
      target="_blank"
    >
      <img
        alt="logo"
        class="share-data__logo-image"
        data-cy="branding-preview-logo"
        :src="props.project.company_logo"
      />
    </a>
    <div class="share-data__info">
      <h4
        class="share-data__company-name"
        data-cy="branding-preview-company_name"
        v-text="$options.companyName(props.project)"
      />
      <div
        class="share-data__description"
        data-cy="branding-preview-company_description"
        v-html="$options.companyDescription(props.project)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareData',
  props: {
    project: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  companyLink: (project) => project.company_link || '',
  companyName: (project) => project.company_name || '',
  companyDescription: (project) => project.company_desc || '',
};
</script>

<style lang="scss" scoped>
.share-data {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  padding: 0 8px;
}

@media screen and (min-width: 960px) {
  .share-data {
    padding-left: 0;
    padding-right: 0;
  }
}

.share-data__logo-link {
  display: block;
  padding: 8px 0 0;
}
.share-data__info {
  padding: 8px 0 0;
  width: 280px;
}

.share-data__logo-image {
  width: auto;
  max-height: 60px;
}

.share-data__company-name {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: kw-color(kw-black, 1);
}

.share-data__description {
  color: #909399;
  font-size: 13px;
  line-height: 16px;
  word-break: break-word;
}

@media (min-width: 960px) {
  .share-data {
    flex-flow: row nowrap;
  }
}
</style>
